import { Component, Prop, State, h } from '@stencil/core';
import whatsappImage from './assets/images/whatsapp-logo.svg'
import close from './assets/images/close.svg'
import send from './assets/images/send.svg'

@Component({
  tag: 'whatsapp-widget',
  styleUrl: 'whatsapp-widget.css',
  shadow: true,
})
export class WhatsappWidget {
  @State() name: string = '';
  @State() email: string = '';
  @State() mobile: string = '';
  @State() message: string = '';
  @State() errors: { [key: string]: string } = {};
  @State() isChatBoxVisible: boolean = false;

  @Prop() phoneNumber: string;
  @Prop() apiKey: string ;

  validateForm() {
    let formIsValid = true;
    const errors: { [key: string]: string } = {};

    if (!this.name) {
      formIsValid = false;
      errors['name'] = 'Name is required.';
    }
    if (!this.email) {
      formIsValid = false;
      errors['email'] = 'Email is required.';
    }
    if (!this.mobile) {
      formIsValid = false;
      errors['mobile'] = 'Mobile Number is required.';
    }
    if (!this.message) {
      formIsValid = false;
      errors['message'] = 'Message is required.';
    }

    this.errors = errors;
    return formIsValid;
  }

  handleSubmit() {
    if (this.validateForm()) {
      const whatsappUrl = `https://api.whatsapp.com/send?phone=${this.phoneNumber}&text=${encodeURIComponent(this.message)}&app_absent=0`;
      window.open(whatsappUrl, '_blank');
      const inleadsEventKey = (window as any).inleadsEvents;
        inleadsEventKey.setUser(this.email, this.name, {
          phoneNumber: this.mobile,
          description: this.message
        });
    this.name="";
    this.mobile="";
    this.email="";
    this.message="";
    }
  }

  toggleChatBox() {
    this.isChatBoxVisible = !this.isChatBoxVisible;
  }

  componentDidLoad() {
    const script = document.createElement('script');
    script.src = "https://cdn.jsdelivr.net/npm/@inleads/event-logger/dist/events.js";
    script.type = 'text/javascript';
    script.onload = () => {
    const inleadsEventKey = (window as any).inleadsEvents
    inleadsEventKey.init(this.apiKey);
    inleadsEventKey.track('VISIT')
    };
    document.body.appendChild(script);
  }

  render() {
    return (
      <div class="whatsapp-container">
  {!this.isChatBoxVisible ? (
    <div class="chat-circle" onClick={() => this.toggleChatBox()}>
      <img src={whatsappImage} class="whatsapp-image" alt="WhatsApp Logo" />
    </div>
  ) : (
    <div class="chat-box">
      <div class="chat-box-header">
        <span class="chat-title">Chat with Us</span>
        <span class="chat-box-toggle" onClick={() => this.toggleChatBox()}>
          <img src={close} alt="Close" />
        </span>
      </div>

      <div class="chat-box-body">
        <div class="chat-box-overlay">
          <div class="chat-logs">
            <form>
              <div class="form-group">
                <label>
                  <span class="required">*</span>Name
                </label>
                <input
                  type="text"
                  value={this.name}
                  onInput={(e:any) => (this.name = e.target.value)}
                  class="form-control"
                />
                {this.errors['name'] && <div class="error-message">{this.errors['name']}</div>}
              </div>
              <div class="form-group">
                <label>
                  <span class="required">*</span>Email
                </label>
                <input
                  type="email"
                  value={this.email}
                  onInput={(e:any) => (this.email = e.target.value)}
                  class="form-control"
                />
                {this.errors['email'] && <div class="error-message">{this.errors['email']}</div>}
              </div>
              <div class="form-group">
                <label>
                  <span class="required">*</span>Mobile
                </label>
                <input
                  type="tel"
                  value={this.mobile}
                  onInput={(e:any) => (this.mobile = e.target.value)}
                  class="form-control"
                />
                {this.errors['mobile'] && <div class="error-message">{this.errors['mobile']}</div>}
              </div>
              <div class="form-group">
                <label>
                  <span class="required">*</span>Message
                </label>
                <textarea
                  rows={3}
                  value={this.message}
                  onInput={(e:any) => (this.message = e.target.value)}
                  class="form-control"
                ></textarea>
                {this.errors['message'] && <div class="error-message">{this.errors['message']}</div>}
              </div>
            </form>
          </div>
          <div class="send-button">
            <img
              src={send}
              alt="Send"
              onClick={() => this.handleSubmit()}
              class="send-image"
            />
          </div>
          <div class="chat-accreditation">
            Powered by <a href="https://inleads.ai" target="_blank">inleads.ai</a>
          </div>
        </div>
      </div>
    </div>
  )}
</div>

    );
  }
}
